import modal from "bootstrap/js/src/modal";

const PER_TE_MODAL = "#per-te-modal";
const OPEN_MODAL_CLASS = ".open-per-te-modal";
const MODAL_CONTENT_SECTION = "#per-te-modal-content .per-te-step-content";
const MODAL_LOADING_SECTION = "#per-te-modal-content .per-te-loading-content";
const MODAL_CURRENT_STEP_URI = "/per-te/current-step";
const MODAL_SUBMIT_URI = "/per-te/submit";

const MODAL_PREVIOUS = "#per-te-modal #per-te-previous";
const MODAL_NEXT = "#per-te-modal #per-te-next";

const perTeModal = new modal(PER_TE_MODAL);

let isCoursePage = !!$('#per-te-modal').data('course')


$(function () {
    // Open modal
    onOpenModalClassClicked()

    onPerTeUrlOpenRequested()

    onCheckboxInputChanged()
    onNextButtonClicked()
    onBackButtonClicked()
    onIgnoreButtonClicked()
    onLoginFormSubmitted()
    onRegistrationFormSubmitted()

    onFinalStepLoaded()
    onGoToRegistrationButtonClicked()
    onGoToLoginClicked()

    onRestartButtonClicked()
    onCoursesStepLoaded()
    onRelatedCategoryClicked()
});

if (isCoursePage) {
    openModal(true)
}

function onPerTeUrlOpenRequested () {
    const urlParams = new URLSearchParams(window.location.search);
    const isPerTeOpenRequested = urlParams.get('per_te');

    if (isPerTeOpenRequested) {
        openModal()
    }
}

function onRestartButtonClicked() {
    $(document).on('click', '#restart-per-te', function () {
        loading()
        submitStep({
            'action': 'restart'
        }).then(() => {
        }).catch(() => {
            showMessage('danger', 'Errore inatteso, riprova tra qualche minuto')
        }).always(() => {
            getCurrentModalContent()
        });
    })
}

function onGoToLoginClicked() {
    $(document).on('click', '#perte-goto-login', function () {
        const loginForm = $("#login-form")
        const registrationForm = $("#registration-form")
        const title = $('#complete-step-title')

        registrationForm.addClass('d-none')
        title.text('Accedi')
        loginForm.removeClass('d-none')
    })
}

function onGoToRegistrationButtonClicked() {
    $(document).on('click', '#perte-goto-registration', function () {
        const loginForm = $("#login-form")
        const registrationForm = $("#registration-form")
        const title = $('#complete-step-title')

        loginForm.addClass('d-none')
        title.text('Registrati ora')
        registrationForm.removeClass('d-none')
    })
}

function onFinalStepLoaded() {
    $(document).on('final_step', function () {
        const loaderCopy = $("#loader-copy")
        loaderCopy.html("Stiamo preparando la selezione di corsi migliori per te…")

        setTimeout(() => {
            loaderCopy.html("Ancora un attimo di pazienza, ci siamo quasi...")
        }, 2500)

        setTimeout(() => {
            submitStep({
                'action': 'next'
            }).then(() => {
                getCurrentModalContent()
            })
        }, 3000)
    })
}

function onCoursesStepLoaded() {
    $(document).on('courses_step_loaded', function () {
        showRelatedCategories()
    });
}

function courseSectionLoading(isLoading = true) {
    const courseSection = $("#courses-section")
    const courseLoading = courseSection.find('.loading')
    const courseContent = courseSection.find('.content')

    if (isLoading) {
        courseLoading.removeClass('d-none')
        courseContent.addClass('d-none')
        return;
    }

    courseLoading.addClass('d-none')
}

function onRelatedCategoryClicked() {

    $(document).on('click', '.category-item', function () {
        const $this = $(this)
        const categoryId = $this.data('category_id')

        courseSectionLoading()
        $(".category-item").removeClass('selected')
        $this.addClass('selected')

        getCourses(categoryId)
    })
}

function showCoursesContent(content) {

    const courseContent = $("#courses-section").find('.content')
    courseContent.html(content)
    courseContent.removeClass('d-none')
}

function getCourses(categoryId) {
    $.ajax({
        url: '/per-te/related-courses',
        data: {category_id: categoryId},
        method: 'POST',
        xhrFields: {
            withCredentials: true
        }
    }).then(response => {
        courseSectionLoading(false)
        if (response.success) {
            showCoursesContent(response.data.html)
        }
    }).catch(error => {

    })
}

function showRelatedCategories() {
    const categoriesSection = $("#categories-section")

    $.ajax({
        url: '/per-te/related-categories',
        method: 'POST',
        xhrFields: {
            withCredentials: true
        }
    }).then((response) => {
        if (response.success) {
            const html = response.data.html
            categoriesSection.html(html)

            // Complete per-te modal
            submitStep({action: 'next', 'step': 'courses'})

            var slider = tns({
                container: '.per-te-categories-slider',
                items: 1.3,
                controls: false,
                nav: false,
                navPosition: 'bottom',
                autoplay: true,
                autoplayButtonOutput: false,
                autoplayResetOnVisibility: false
            });

            getCourses()
        }
    }).catch((e) => {

    })
}

function onRegistrationFormSubmitted() {
    $(document).on('submit', '#registration-form', function (e) {
        e.preventDefault()
        if (!$('#per-te-registration-error').hasClass('d-none')) {
            $('#per-te-registration-error').addClass('d-none')
            $('#per-te-registration-error-msg').empty()
        }
        const $form = $(this)
        const registrationButton = $form.find('button[type="submit"]');

        registrationButton.html("In corso <div class=\"spinner-border text-light mx-2\" style='width: 17px; height: 17px' role=\"status\"></div>")
        registrationButton.prop('disabled', true)

        $.ajax({
            url: '/per-te/authenticate',
            data: $form.serialize(),
            method: 'POST',
            xhrFields: {
                withCredentials: true
            }
        }).then((response) => {
            analytics ? analytics("event", "sign_up", {event_label: "per_te"}) : '';
            window.location = "?per_te=1";
        }).catch((e) => {
            let error = e.responseJSON.error.message
            if (error) {
                $('#per-te-registration-error').removeClass('d-none')
                if (error === 'The email has already been taken.') {
                    showErrorMessage('register', 'Attenzione, utente già esistente')
                } else {
                    showErrorMessage('register', 'Si è verificato un errore, riprovare più tardi')
                }
            }
            registrationButton.html("Registrati")
            registrationButton.prop('disabled', false)
        })
    })
}

function isFieldConfirmedCorrectly(field, confirmedField) {
    const fieldErrorMessage = $('small[data-validation="'+field.attr('id')+'"]')
    const confirmedFieldErrorMessage = $('small[data-validation="'+confirmedField.attr('id')+'"]')

    fieldErrorMessage.hide()
    confirmedFieldErrorMessage.hide()

    field.removeClass('is-invalid')
    confirmedField.removeClass('is-invalid')

    if (field.val() !== confirmedField.val()) {
        field.addClass('is-invalid')
        confirmedField.addClass('is-invalid')

        fieldErrorMessage.text('I campi inseriti non combaciano')
        confirmedFieldErrorMessage.text('I campi inseriti non combaciano')

        fieldErrorMessage.show()
        confirmedFieldErrorMessage.show()

        return false;
    }

    return true;
}

function showInputErrorMessage(field, message) {
    const fieldErrorMessage = $('small[data-validation="'+field.attr('id')+'"]')
    fieldErrorMessage.text(message)
    fieldErrorMessage.show()
}

function showErrorMessage(type, msg) {

    if (type === 'login') {
        $('#per-te-login-error').removeClass('d-none')
        $('#per-te-login-error-msg').append(msg)
    }

    if (type === 'register') {
        $('#per-te-registration-error').removeClass('d-none')
        $('#per-te-registration-error-msg').append(msg)
    }

}

function onLoginFormSubmitted() {
    $(document).on('submit', '#login-form', function (e) {
        e.preventDefault()

        if (!$('#per-te-login-error').hasClass('d-none')) {
            $('#per-te-login-error').addClass('d-none')
            $('#per-te-login-error-msg').empty()
        }

        const $form = $(this)
        const loginButton = $form.find('button[type="submit"]')
        const emailInput = $form.find('input[type="email"]')
        const passwordInput = $form.find('input[type="password"]')
        const emailInvalidMessage = $form.find('small[data-validation="'+emailInput.attr('id')+'"]')
        const passwordInvalidMessage = $form.find('small[data-validation="'+passwordInput.attr('id')+'"]')

        emailInput.removeClass('is-invalid')
        passwordInput.removeClass('is-invalid')
        emailInvalidMessage.hide()
        passwordInvalidMessage.hide()
        loginButton.html("In corso <div class=\"spinner-border text-light mx-2\" style='width: 17px; height: 17px' role=\"status\"></div>")
        loginButton.prop('disabled', true)

        $.ajax({
            url: '/per-te/authenticate',
            data: $form.serialize(),
            method: 'POST',
            xhrFields: {
                withCredentials: true
            }
        }).then(() => {
            analytics ? analytics("event", "login", {event_label: "per_te"}) : '';
            window.location = "?per_te=1";
        }).catch(() => {
            loginButton.html("Accedi")
            loginButton.prop('disabled', false)
            emailInput.addClass('is-invalid')
            passwordInput.addClass('is-invalid')
            showErrorMessage('login', 'Errore, controlla le credenziali e riprova')
        })
    })
}

function onIgnoreButtonClicked() {
    $(document).on('click', '#per-te-ignore', function () {
        const modalContent = $('#per-te-modal-content')
        const form = modalContent.find('form')
        form.append("<input type='hidden' name='action' value='ignore'/>")
        loading()
        submitStep(form.serialize()).then(() => {
        }).catch(() => {
            // TODO: Show error message
        }).always(() => {
            getCurrentModalContent()
        });
    })
}

function onBackButtonClicked() {
    $(document).on('click', MODAL_PREVIOUS, function () {
        const modalContent = $('#per-te-modal-content')
        const form = modalContent.find('form')
        form.append("<input type='hidden' name='action' value='back'/>")
        loading()
        submitStep(form.serialize()).then(() => {
        }).catch(() => {
            // TODO: Show error message
        }).always(() => {
            getCurrentModalContent()
        });
    })
}

function doNextRequest() {
    const modalContent = $('#per-te-modal-content')
    const form = modalContent.find('form')

    if (!validateForm(form)) {

        return;
    }

    form.append("<input type='hidden' name='action' value='next'/>")

    loading()
    submitStep(form.serialize()).then(() => {
    }).catch(error => {
        showMessage('danger', 'Errore inatteso, riprova tra qualche minuto')
    }).always(() => {
        getCurrentModalContent()
    });
}

function onNextButtonClicked() {
    $(document).on('click', MODAL_NEXT, function () {
        doNextRequest()
    })
}

function onCheckboxInputChanged() {
    $(document).on('change', '#per-te-modal-content .per_te-checkbox .form-check-input', function () {
        const $this = $(this)
        const isChecked = $this.prop('checked');
        const labelClicked = $this.siblings('.form-check-label');
        const isSubmitter = $this.data('submitter')

        if (isChecked) {
            const modalContent = $('#per-te-modal-content')
            const form = modalContent.find('form')

            if (! validateForm(form, false)) {
                $this.prop('checked', false)
                return;
            }

            if ($this.data('validated:type') === 'deselect') {
                form.find('input[type="checkbox"]').not($this).prop('checked', false)
                form.find('label').not(labelClicked).removeClass('checked')
            }

            if (isSubmitter) {
                doNextRequest()
            }
        }

        labelClicked.toggleClass('checked')
    })
}

function onOpenModalClassClicked() {
    $(document).on('click', OPEN_MODAL_CLASS, function (e) {
        e.preventDefault()
        $('[data-bs-dismiss="offcanvas"]').trigger('click');
        isCoursePage = false
        openModal()
    });
}

function openModal() {
    if (isCoursePage) {
        $('.btn-close').addClass('d-none')
        $('#per-te-course-alert').removeClass('d-none')
        $('#per-te-modal-content').addClass('flex-column')
    } else {
        $('#per-te-modal').removeAttr('data-course')
        $('#per-te-course-alert').addClass('d-none')
        $('#per-te-modal-content').removeClass('flex-column')
    }

    perTeModal.show()
    loading()

    if($(PER_TE_MODAL).data('is-typeform-modal') === 0) {
        getCurrentModalContent()
    }
}

function getCurrentModalContent() {
    let url = MODAL_CURRENT_STEP_URI
    
    if (isCoursePage) {
        url = url + '?type=course'
    }

    return $.ajax({
        url: url,
        method: 'GET',
        xhrFields: {
            withCredentials: true
        }
    }).then(htmlContent => {
        if (htmlContent.data.show_close_btn && htmlContent.data.show_close_btn === true) {
            $('.btn-close').removeClass('d-none')
            setTimeout(() => {
                perTeModal.hide()
            }, 2000)
        }
        loading(false)
        showContent(htmlContent.data.html)
    }).catch(() => {
        showMessage('danger', 'Errore inatteso, riprova tra qualche minuto')
    })
}

function submitStep(data) {
    return $.ajax({
        url: MODAL_SUBMIT_URI,
        data: data,
        method: 'POST',
        xhrFields: {
            withCredentials: true
        }
    })
}

function showContent(contentToShow) {
    const contentSection = $(MODAL_CONTENT_SECTION)
    contentSection.html(contentToShow)
    contentSection.removeClass('d-none')
}

function loading(show = true) {
    const loadingSection = $(MODAL_LOADING_SECTION)

    if (show) {
        const loadingSiblings = loadingSection.siblings('div')

        loadingSection.removeClass('d-none')
        loadingSiblings.addClass('d-none')

        return;
    }

    loadingSection.addClass('d-none')
}

function validateForm(form, onSubmit = true) {
    let isValid = true;
    form.find('*[data-validated]').each((key, item) => {
        const $item = $(item)

        if ($item.data('validation:type') === 'checkbox') {
            const limit = $item.data('validation:limit');
            const min = $item.data('validation:min');
            const fieldName = $item.attr('name') || $item.data('validation:name')
            const inputChecked = form.find('input[name="' + fieldName + '"]:checked');

            if (limit !== undefined) {
                if (inputChecked.length > limit) {
                    showMessage("danger", "Superato il limite massimo di opzioni selezionabili.")
                    isValid = false;
                }
            }

            if (min !== undefined && onSubmit) {
                if (inputChecked.length < min) {
                    const message = "Selezionare almeno " + min + (min === 1 ? " opzione" : " opzioni");
                    showMessage("danger", message)
                    isValid = false;
                }
            }
        }
    })

    return isValid;
}

function showMessage(type, message) {
    const alert = $("#per-te-alert")

    alert.addClass('bg-' + type)
    alert.find('div.toast-body').html(message)
    alert.show()

    setTimeout(() => {
        alert.hide()
    }, 2000)
}
